import React from "react";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { TiHome } from "react-icons/ti";
import { AiOutlineLogout } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";

const Dashboardsidenav = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("userdata");
    navigate("/");
  };

  return (
    <div
      className="h-[400px] bg-transparent border-[1px]  border-[#D4F5F9] border-opacity-30 w-[118px] gap-20 grid place-content-center rounded-md"
      
    >
      <div>
        <Link to="/dashboard">
          <TiHome className="text-[#F2C493] text-[40px]" />
        </Link>
      </div>
      <div>
        <Link to="/transaction">
          <LiaFileInvoiceDollarSolid className="text-[#F2C493] text-[40px]" />
        </Link>
      </div>
      <div>
        <button onClick={handleLogout}>
          <AiOutlineLogout className="text-[#F2C493] text-[40px]" />
        </button>
      </div>
    </div>
  );
};

export default Dashboardsidenav;
